import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { throwError as observableThrowError, Observable } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { AuthenticationService } from "../views/authentication.service";
import * as moment from "moment";
import { parseFileName } from "../common/commonHelper";

@Injectable({
  providedIn: "root",
})
export class AttachmentsService {
  uploadUrl: string;
  constructor(
    private http: HttpClient,
    private _headerService: AuthHeaderService,
    private _authservice: AuthenticationService
  ) {
    this.uploadUrl = environment.uploadUrl;
  }

  // upload(file: File): Observable<HttpEvent<any>> {
  //   const formData: FormData = new FormData();

  //   formData.append("file", file);
  //   let options = new RequestOptions({
  //     headers: this._headerService.getHeader(),
  //   });
  //   return this.http.post(this.uploadUrl, formData, options).pipe(
  //     map((response) => response.json()),
  //     catchError((error: Response) => {
  //       return observableThrowError(error);
  //     })
  //   );
  // }

  upload(companyName, formName, formData) {
    //let options = this._headerService.getFileHeader();

    let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    // let formdata2 : FormData = new FormData();
    // formdata2                = formData
    let token = localStorage.getItem('token');
    let options = {
      headers: new HttpHeaders({
        Authorization: "Bearer " +token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
        formName:'loads',
        'enctype': 'multipart/form-data'
      }),
    };
    // let some = formData.getAll('file');
    // console.log(some);



    // formdata2.append('some', "cdef")



    var resp= this.http
    .post(
        this.uploadUrl + "/" + companyName + "/" + formName,
        formData,
        options
      )
      .pipe(
        map((response: any) => {
          return response || [];
        }),
        catchError((error: any) => {
          return observableThrowError(error);
        })
        );
        return resp
  }


  async uploadNew(companyName, formName, formData) {
    //let options = this._headerService.getFileHeader();

    let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    let token = localStorage.getItem('token');
    let options = {
      headers: new HttpHeaders({
        Authorization: token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin":"*"
      }),
    };

    var resp
    await fetch(this.uploadUrl + "/" + companyName + "/" + formName,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: "Bearer "+ token,
              company: localStorage.getItem("selectedCompany"),
              reportProgress: "true",
              responseType: "json",
              "enable-cors" : "true",
            }
          })
          .then((response) => {
            resp =  response.json()
          })
    // = this.http
    // .post(
    //     this.uploadUrl + "/" + companyName + "/" + formName,
    //     formData,
    //     options
    //   )
    //   .pipe(
    //     map((response: any) => {
    //       return response || [];
    //     }),
    //     catchError((error: any) => {
    //       return observableThrowError(error);
    //     })
    //     );

        return resp
  }
  deleteFile(companyName, formName, fileName) {
    // let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    let token = localStorage.getItem('token');
    let options = {
      headers: new HttpHeaders({
        Authorization: "Bearer "+ token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
      }),
    };
    return this.http
      .delete(
        this.uploadUrl + "/" + companyName + "/" + formName + "/" + fileName,
        options
      )
      .pipe(
        map((response: any) => {
          return response || [];
        }),
        catchError((error: any) => {
          return observableThrowError(error);
        })
      );
  }

  async deleteFileNew(companyName, formName, fileName) {
    // let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    let token = localStorage.getItem('token');
    let options = {
      headers: new HttpHeaders({
        Authorization: "Bearer "+ token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
      }),
    };
    // return this.http
    //   .delete(
    //     this.uploadUrl + "/" + companyName + "/" + formName + "/" + fileName,
    //     options
    //   )
    //   .pipe(
    //     map((response: any) => {
    //       return response || [];
    //     }),
    //     catchError((error: any) => {
    //       return observableThrowError(error);
    //     })
    //   );
    var resp
    await fetch(this.uploadUrl + "/" + companyName + "/" + formName + "/" + fileName,
    {
      method: "DELETE",
      headers: {
        Authorization: "Bearer "+ token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
        "enable-cors" : "true",
      }
    })
    .then((response) => {
      resp =  response.json()
    })
    return resp
  }

  getFiles(): Observable<any> {
    // let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    let token = localStorage.getItem('token');
    let options = {
      headers: new HttpHeaders({
        Authorization: token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
      }),
    };
    return this.http.get(this.uploadUrl, options);
  }
  async uploadMethod(uploadedFileData): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      let fileInfo = [];
      let fileResponse = {};
      let uploadedFiles = [];
      // console.log(uploadedFileData);
      //fileInfo = uploadedFileData.fileInfo;
      uploadedFiles = uploadedFileData.uploadedFiles;
      let formName = uploadedFileData.model;
      var formData: FormData;
      if (uploadedFileData.uploadedFiles.length > 0) {
        formData = new FormData();
        uploadedFiles.forEach(file => {
          // console.log(file);
          formData.append("file", file, parseFileName(file.name) );
          let companyName = localStorage
            .getItem("selectedCompanyName")
            .toLowerCase()
            .split(" ")
            .join("_");
          this.uploadNew(companyName, formName, formData).then(
            (response) => {
              // console.log(response);
              if (response.status === "success") {

                fileResponse["orginalName"] = response.orginalName;
                fileResponse["fileName"] = response.fileName;
                fileResponse["fileUrl"] = response.fileUrl;
                fileResponse["fileDestination"] = response.fileDestination;
                fileResponse["fileSize"] = response.fileSize;
                fileResponse["createdDate"] = moment(response.createdDate).format(
                  "MM/DD/YYYY"
                );
                fileResponse["modifiedDate"] = moment(response.modifiedDate).format(
                  "MM/DD/YYYY"
                );

                fileInfo.push(fileResponse);
                // console.log(fileInfo);
              }
            },
            (err) => { console.log(err); }
          );
        });


      }
    });
  }
  async ImageRead(company, model, fileName) {
    let token = localStorage.getItem('token');

    let resp
    if(company && model && fileName){

    await fetch(this.uploadUrl + "/" + company + "/" + model + "/" + fileName,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer "+ token,
          company: localStorage.getItem("selectedCompany"),
          "request-type": "read",
          reportProgress: "true",
          responseType: "json",
          "enable-cors" : "true",
        }
      })
      .then((response) => {
        resp =  response.arrayBuffer()
      })
      .catch(err=>{
        return null
      })
      return resp
    }
    else{
      return null
    }
  }
  async PdfImageRead(imageType="") {
    let token = localStorage.getItem('token');

    var resp;
    let headers = {
      Authorization: "Bearer "+ token,
      company: localStorage.getItem("selectedCompany"),
      reportProgress: "true",
      responseType: "json",
      "image-type": imageType,
      "enable-cors" : "true",
    }
    await fetch(this.uploadUrl + "/readpdf",
          {
            method: "GET",
            headers: headers
          })
          .then((response) => {
            resp =  response.arrayBuffer()
          })

        return resp
  }

}
